import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import UnderpaidWarningPopup from './UnderpaidWarningPopup';

export default injectIntl(withRouter(UnderpaidWarningPopup));
